const convertNumber = (value, locale) => {
    return value.toLocaleString(locale);
};

export default convertNumber;
